import { REGION_KEY } from 'shared/components/RegionSwitcher/constants';
/**
 * Kept apart from `regionAvailability` because `src/api` reaches this through `RegionProvider`:
 * neither this file nor anything it imports may pull in UI modules.
 */
export var getPathWithRegion = function getPathWithRegion(path, region) {
    var url = new URL(path, window.location.origin);
    url.searchParams.set(REGION_KEY, region);
    return "".concat(url.pathname).concat(url.search);
};
